import { render, staticRenderFns } from "./BaseCheckbox.vue?vue&type=template&id=3e82bdac&"
import script from "./BaseCheckbox.vue?vue&type=script&lang=js&"
export * from "./BaseCheckbox.vue?vue&type=script&lang=js&"
import style0 from "./BaseCheckbox.vue?vue&type=style&index=0&id=3e82bdac&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/prodoctorov/pd-ssr/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3e82bdac')) {
      api.createRecord('3e82bdac', component.options)
    } else {
      api.reload('3e82bdac', component.options)
    }
    module.hot.accept("./BaseCheckbox.vue?vue&type=template&id=3e82bdac&", function () {
      api.rerender('3e82bdac', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "www/vue_components/common/core/BaseCheckbox.vue"
export default component.exports